import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import dayjs from "dayjs";
import styled from "styled-components";
import Flex from "../../../../../DefaultStyles/Flex";
import SpaceBetween from "../../../../../DefaultStyles/SpaceBetween";
import { AxiosResponse } from "axios";
import { useApi } from "../../../../../../hooks/useApi";
import { inviteMemberEmailConverter } from "../../../../../../scCommon/scCommonFunc";
import Loader from "../../../../../DefaultStyles/Loader";
import { useRecoilState } from "recoil";
import { mailRefreshState } from "../PartyMailModal";
import { toast } from "react-toastify";

interface PartyMailFirstContentProps {
  setClick: Dispatch<
    SetStateAction<{
      isClick: boolean;
      url: string;
      data: {
        receiver: string;
        url: string;
        sender: string;
      };
    }>
  >;
  setMailStatus: Dispatch<SetStateAction<string | undefined>>;
  isInviteMail?: boolean;
  response?: AxiosResponse;
  loading?: boolean;
  partyData?: {
    member: string;
    party: string;
    memberEmail: string;
  };
  mailId?: string;
  setTimeStamp: Dispatch<SetStateAction<string>>;
  secondaryMailAcc?: string;
  subsId?: number;
  saveMailIndex: (id: number) => void;
  type?: string;
}

interface IMailList {
  headers: {
    from: string;
    subject: string;
    to: string;
  };
  timestamp: number;
  storage: {
    url: string;
    key: string;
    region: string;
  };
  status?: string;
  var?: string;
  hasResend?: string;
}

interface SStatusText {
  status?: string;
}

interface INewMailList {
  id: number;
  recvid: string;
  date: string;
  subject: string;
  from: string;
}

export default function PartyMailList({
  setClick,
  setMailStatus,
  isInviteMail,
  partyData,
  mailId,
  setTimeStamp,
  secondaryMailAcc,
  subsId,
  saveMailIndex,
  type,
}: PartyMailFirstContentProps) {
  const [refetch, setRefetch] = useRecoilState(mailRefreshState);
  const [mailList, setMailList] = useState<IMailList[]>([]);
  const [newMailList, setNewMailList] = useState<INewMailList[]>([]);

  // debugger;
  const email =
    secondaryMailAcc ??
    mailId ??
    (partyData
      ? partyData?.memberEmail?.includes("testgrove.pw") ||
        partyData?.memberEmail?.includes("linkidmail.com")
        ? partyData?.memberEmail
        : inviteMemberEmailConverter(
            Number(partyData?.party?.split("_")[0]),
            Number(partyData?.member?.split("_")[0])
          )
      : "");

  console.log(type);

  // 메일 수신 리스트
  const {
    response: inviteMailReceivingResponse,
    loading: inviteMailReceivingLoading,
    fetchData: inviteMailReceivingFetchData,
    error: inviteMailReceivingError,
  } = useApi({
    method: "post",
    url: secondaryMailAcc || type === "mailgun" ? `party/mailList` : undefined,
    data: {
      mail: email,
    },
  });

  // db 메일 리스트
  const {
    response: newResponse,
    loading: newLoading,
    error: newError,
    fetchData: newFetchData,
  } = useApi({
    method: "get",
    url:
      !secondaryMailAcc && Boolean(email) && email?.length > 0 && type === "db"
        ? `mail?email=${email}`
        : undefined,
  });

  useEffect(() => {
    if (newResponse?.status === 200) {
      setNewMailList(newResponse?.data);
    }
  }, [newResponse]);

  useEffect(() => {
    if (newError || inviteMailReceivingError) {
      setRefetch(false);

      toast.error(
        inviteMailReceivingError?.data ??
          newError?.data ??
          newError ??
          "메일 리스트를 가져오는 데에 실패했습니다."
      );
    }
  }, [newError, inviteMailReceivingError]);

  useEffect(() => {
    console.log(inviteMailReceivingResponse?.data);

    if (inviteMailReceivingResponse?.data || newResponse?.data) {
      setRefetch(false);

      const receivingList = inviteMailReceivingResponse?.data ?? []; // 수신 이메일

      if (receivingList?.length > 0) {
        // timestamp 순으로 내림차순 정렬
        const sortByTimestamp = receivingList?.sort(
          (a: { timestamp: number }, b: { timestamp: number }) =>
            b.timestamp - a.timestamp
        );

        setMailList(sortByTimestamp);
      }
    }
  }, [inviteMailReceivingResponse, newResponse]);

  useEffect(() => {
    if (refetch) {
      if (type === "mailgun" || secondaryMailAcc) {
        inviteMailReceivingFetchData({
          method: "post",
          url: type === "mailgun" ? `party/mailList` : undefined,
          data: {
            mail:
              secondaryMailAcc ??
              mailId ??
              (partyData
                ? inviteMemberEmailConverter(
                    Number(partyData?.party?.split("_")[0]),
                    Number(partyData?.member?.split("_")[0])
                  )
                : ""),
          },
        });
      }

      if (type === "db") {
        newFetchData({
          method: "get",
          url:
            !secondaryMailAcc && Boolean(email) && email?.length > 0
              ? `mail?email=${email}`
              : "",
        });
      }
    }
  }, [refetch, secondaryMailAcc, mailId, email]);

  return (
    <>
      {isInviteMail && <MailListTitle>메일 목록</MailListTitle>}

      {!inviteMailReceivingLoading && (
        <MailListContainer>
          {type === "db" ? (
            newMailList?.length > 0 ? (
              newMailList?.map((n) => (
                <MailItemContainer
                  key={n.id}
                  onClick={() => saveMailIndex(n.id)}
                >
                  <MailItem>
                    <SpaceBetween>
                      <MailSender>{n?.from}</MailSender>

                      <Flex gapSize={2}>
                        {!isInviteMail ? (
                          <SendingDate>
                            {dayjs?.(n?.date)?.format("YYYY.MM.DD HH:mm:ss")}
                          </SendingDate>
                        ) : (
                          <SendingDate>
                            {dayjs?.(n?.date)?.format("YYYY.MM.DD HH:mm:ss")}
                          </SendingDate>
                        )}

                        <Arrow className="material-icons-outlined">
                          chevron_right
                        </Arrow>
                      </Flex>
                    </SpaceBetween>

                    <Title>{n?.subject}</Title>
                  </MailItem>
                </MailItemContainer>
              ))
            ) : (
              <Title>메일이 없습니다.</Title>
            )
          ) : mailList?.length > 0 ? (
            mailList?.map((d: IMailList, i: number) => (
              <MailItemContainer key={i}>
                <MailItem
                  onClick={() => {
                    setTimeStamp(
                      dayjs?.unix(d?.timestamp)?.format("YYYY-MM-DD HH:mm:ss")
                    );
                    setMailStatus(
                      `${d?.hasResend === "1" ? "resent " : ""}${d?.status}`
                    ); // 메일 상태 저장
                    setClick({
                      isClick: true,
                      url: d?.storage?.url,
                      data: {
                        receiver: partyData?.memberEmail ?? "",
                        url: d?.storage?.url,
                        sender: inviteMemberEmailConverter(
                          Number(partyData?.party?.split("_")[0]),
                          Number(partyData?.member?.split("_")[0])
                        ),
                      },
                    });
                  }}
                  key={d?.timestamp}
                >
                  {isInviteMail && (
                    <StatusRow>
                      {/* delivered: 포워드 성공 / accepted: 포워드 대기 / failed: 포워드 실패 / stored: 포워드 안함 (필터 데이터 기반)*/}
                      <StatusText status={d?.status}>
                        {d?.status === "delivered"
                          ? `${
                              d?.hasResend === "1" ? "재발송 " : ""
                            }포워드 성공`
                          : d?.status === "accepted"
                          ? `${
                              d?.hasResend === "1" ? "재발송 " : ""
                            }포워드 대기`
                          : d?.status === "stored"
                          ? `${
                              d?.hasResend === "1" ? "재발송 " : ""
                            }포워드 안함 (필터 데이터 기반)`
                          : `${
                              d?.hasResend === "1" ? "재발송 " : ""
                            }포워드 실패`}
                      </StatusText>

                      <SendingDate>
                        {dayjs
                          ?.unix(d?.timestamp)
                          ?.format("YYYY.MM.DD HH:mm:ss")}
                      </SendingDate>
                    </StatusRow>
                  )}
                  <SpaceBetween>
                    <MailSender>{d?.headers?.from}</MailSender>

                    <Flex gapSize={2}>
                      {!isInviteMail ? (
                        <SendingDate>
                          {dayjs
                            ?.unix(d?.timestamp)
                            ?.format("YYYY.MM.DD HH:mm:ss")}
                        </SendingDate>
                      ) : (
                        <div />
                      )}

                      <Arrow className="material-icons-outlined">
                        chevron_right
                      </Arrow>
                    </Flex>
                  </SpaceBetween>

                  <Title>{d?.headers?.subject}</Title>
                </MailItem>
              </MailItemContainer>
            ))
          ) : (
            <Title>메일이 없습니다.</Title>
          )}
        </MailListContainer>
      )}

      {(inviteMailReceivingLoading || newLoading) && <Loader />}
    </>
  );
}

const StatusRow = styled.div`
  width: calc(100% - 34.5px);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 7px;
  border-bottom: 1px solid ${({ theme }) => theme.buttonColor.lineNormal};
  margin-bottom: 7px;
`;

const StatusText = styled.span<SStatusText>`
  font-size: 13px;
  font-weight: 500;
  line-height: 19.5px;
  text-align: left;
  color: ${({ status, theme }) =>
    status === "delivered"
      ? theme.buttonColor.bluePressed
      : status === "accepted"
      ? theme.color.yellow
      : theme.buttonColor.redNormal};
`;

const MailListTitle = styled.div`
  font-size: 14px;
  font-weight: bold;
  line-height: 21px;
  text-align: left;
  color: #9a9fa8;
  margin-top: 40px;
  margin-bottom: 10px;
`;

const MailListContainer = styled.div`
  margin-top: 20px;
  margin-bottom: 40px;
`;

const MailItemContainer = styled(Flex)`
  &:not(:last-child) {
    margin-bottom: 10px;
  }
`;

const MailItem = styled.div`
  cursor: pointer;
  width: 100%;
  min-height: 60px;
  border-radius: 3px;
  background-color: ${({ theme }) => theme.color.bgColor};
  padding: 11px 16px;
`;

export const MailSender = styled.span`
  font-size: 14px;
  font-weight: bold;
  text-align: left;
  color: ${({ theme }) => theme.color.gray700};
`;

const Title = styled.span`
  font-size: 13px;
  line-height: 19.5px;
  text-align: left;
  color: ${({ theme }) => theme.color.gray600};
`;

export const SendingDate = styled.span`
  font-size: 13px;
  line-height: 19.5px;
  text-align: right;
  color: #858c97;
`;

const Arrow = styled.span`
  color: #858c97;
`;
